// Bejelentkezés utáni visszalépés kezelése (akkor is működik, ha a belépés külső oldalon – Facebook, Google – keresztül történik).
//
// A RouteTracker minden oldalváltáskor eltárolja az utolsó "normál" oldalt. Bejelentkezés után az /after-login
// oldal ide navigál vissza ("-1 oldal"); ha nincs ilyen, vagy az a főoldal, akkor a /profile oldalra.

const KEY = 'lastVisitedPath';

// Ezekre az útvonalakra nem térünk vissza bejelentkezés után. Igazítsd a saját útvonalaidhoz!
const BLOCKED_PREFIXES = [
  '/authpages',
  '/login',
  '/belepes',
  '/register',
  '/regisztracio',
  '/sign-in',
  '/sign-up',
  '/after-login',
  '/sso-callback',
];

// true: ha az előző oldal a főoldal ("/"), akkor inkább a /profile oldalra visz
export const SKIP_HOME_AS_RETURN_TARGET = true;

export const isAuthPath = (path: string): boolean =>
  BLOCKED_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`) || path.startsWith(`${p}?`));

export const rememberPath = (path: string): void => {
  try {
    if (!isAuthPath(path)) sessionStorage.setItem(KEY, path);
  } catch {
    /* sessionStorage nem elérhető */
  }
};

/** Visszaadja, hová kell lépni belépés után, és törli a tárolt értéket. */
export const consumePostLoginTarget = (): string => {
  let path: string | null = null;
  try {
    path = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  if (!path || !path.startsWith('/') || isAuthPath(path)) return '/profile';
  if (SKIP_HOME_AS_RETURN_TARGET && (path === '/' || path.startsWith('/?'))) return '/profile';
  return path;
};